"use client";
import {
  createContext,
  Dispatch,
  type PropsWithChildren,
  useContext,
  useReducer,
} from "react";

import {
  reducerSignUp,
  SignUpReducerAction,
  SignUpReducerState,
} from "./sign-up-reducer";

type SignUpContextTypes = {
  signUpReducer: SignUpReducerState;
  setSignUpReducer: Dispatch<SignUpReducerAction>;
};

const SignUpContext = createContext({} as SignUpContextTypes);

const SignUpProvider = ({ children }: PropsWithChildren) => {
  const [signUpReducer, setSignUpReducer] = useReducer<typeof reducerSignUp>(
    reducerSignUp,
    { step: "calculation", signUpStep: 0 }
  );

  return (
    <SignUpContext.Provider
      value={{
        signUpReducer,
        setSignUpReducer,
      }}
    >
      {children}
    </SignUpContext.Provider>
  );
};

const useSignUpContext = () => {
  const context = useContext(SignUpContext);

  if (!context) {
    throw new Error("useSignUp() deve ser usado com um <SignUpProvider />");
  }

  return context;
};

export { SignUpProvider, useSignUpContext, SignUpContext };
